'use strict';

import '../css/app.scss';
import {drawer} from './modules/drawer';
import SmoothScroll from 'smooth-scroll';
import 'lazysizes';
// import {homeHeroImageCarousel} from './modules/homeHeroImageCarousel';

(function (window, document, $) {


    // header Fix

    var ywsa = document.getElementById("is-header");
    var yws_headrfix = function () {
        if (window.pageYOffset > 450) {
            ywsa.classList.add("is-fixed")
        } else {
            ywsa.classList.remove("is-fixed")
        }
    };
    window.addEventListener("load", yws_headrfix);
    window.addEventListener("scroll", yws_headrfix);

    /*Navigation*/

    function navToggle() {
        var toggleBtn = document.getElementById('is-menu-btn');
        var navView = document.getElementById('is-body');
        //var navBody = document.getElementsByTagName('body')[0];
        var toggleBtnClass = toggleBtn.getAttribute('class');

        if (toggleBtnClass == 'o-header_menu-btn') {
            toggleBtn.classList.add('is-active');
            navView.classList.add('is-active');
            //navBody.classList.add('is-fixed');
        }
        else {
            toggleBtn.classList.remove('is-active');
            navView.classList.remove('is-active');
            //navBody.classList.remove('is-fixed');
        }
    }
    document.getElementById('is-menu-btn').onclick = navToggle;

    document.addEventListener('DOMContentLoaded', function () {
        var toggleBtn = document.getElementById('is-menu-btn');
        var navView = document.getElementById('is-body');
        var btns = document.querySelectorAll('.is-close');
        for (var i = 0; i < btns.length; i++) {
            btns[i].addEventListener('click', function () {
                toggleBtn.classList.remove('is-active');
                navView.classList.remove('is-active');
            }, false);
        }
    }, false);



    /*Smooth Scroll behavior polyfill*/

    !function () { "use strict"; function o() { var o = window, t = document; if (!("scrollBehavior" in t.documentElement.style && !0 !== o.__forceSmoothScrollPolyfill__)) { var l, e = o.HTMLElement || o.Element, r = 468, i = { scroll: o.scroll || o.scrollTo, scrollBy: o.scrollBy, elementScroll: e.prototype.scroll || n, scrollIntoView: e.prototype.scrollIntoView }, s = o.performance && o.performance.now ? o.performance.now.bind(o.performance) : Date.now, c = (l = o.navigator.userAgent, new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(l) ? 1 : 0); o.scroll = o.scrollTo = function () { void 0 !== arguments[0] && (!0 !== f(arguments[0]) ? h.call(o, t.body, void 0 !== arguments[0].left ? ~~arguments[0].left : o.scrollX || o.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : o.scrollY || o.pageYOffset) : i.scroll.call(o, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : o.scrollX || o.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : o.scrollY || o.pageYOffset)) }, o.scrollBy = function () { void 0 !== arguments[0] && (f(arguments[0]) ? i.scrollBy.call(o, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : h.call(o, t.body, ~~arguments[0].left + (o.scrollX || o.pageXOffset), ~~arguments[0].top + (o.scrollY || o.pageYOffset))) }, e.prototype.scroll = e.prototype.scrollTo = function () { if (void 0 !== arguments[0]) if (!0 !== f(arguments[0])) { var o = arguments[0].left, t = arguments[0].top; h.call(this, this, void 0 === o ? this.scrollLeft : ~~o, void 0 === t ? this.scrollTop : ~~t) } else { if ("number" == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError("Value could not be converted"); i.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop) } }, e.prototype.scrollBy = function () { void 0 !== arguments[0] && (!0 !== f(arguments[0]) ? this.scroll({ left: ~~arguments[0].left + this.scrollLeft, top: ~~arguments[0].top + this.scrollTop, behavior: arguments[0].behavior }) : i.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop)) }, e.prototype.scrollIntoView = function () { if (!0 !== f(arguments[0])) { var l = function (o) { for (; o !== t.body && !1 === (e = p(l = o, "Y") && a(l, "Y"), r = p(l, "X") && a(l, "X"), e || r);)o = o.parentNode || o.host; var l, e, r; return o }(this), e = l.getBoundingClientRect(), r = this.getBoundingClientRect(); l !== t.body ? (h.call(this, l, l.scrollLeft + r.left - e.left, l.scrollTop + r.top - e.top), "fixed" !== o.getComputedStyle(l).position && o.scrollBy({ left: e.left, top: e.top, behavior: "smooth" })) : o.scrollBy({ left: r.left, top: r.top, behavior: "smooth" }) } else i.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0]) } } function n(o, t) { this.scrollLeft = o, this.scrollTop = t } function f(o) { if (null === o || "object" != typeof o || void 0 === o.behavior || "auto" === o.behavior || "instant" === o.behavior) return !0; if ("object" == typeof o && "smooth" === o.behavior) return !1; throw new TypeError("behavior member of ScrollOptions " + o.behavior + " is not a valid value for enumeration ScrollBehavior.") } function p(o, t) { return "Y" === t ? o.clientHeight + c < o.scrollHeight : "X" === t ? o.clientWidth + c < o.scrollWidth : void 0 } function a(t, l) { var e = o.getComputedStyle(t, null)["overflow" + l]; return "auto" === e || "scroll" === e } function d(t) { var l, e, i, c, n = (s() - t.startTime) / r; c = n = n > 1 ? 1 : n, l = .5 * (1 - Math.cos(Math.PI * c)), e = t.startX + (t.x - t.startX) * l, i = t.startY + (t.y - t.startY) * l, t.method.call(t.scrollable, e, i), e === t.x && i === t.y || o.requestAnimationFrame(d.bind(o, t)) } function h(l, e, r) { var c, f, p, a, h = s(); l === t.body ? (c = o, f = o.scrollX || o.pageXOffset, p = o.scrollY || o.pageYOffset, a = i.scroll) : (c = l, f = l.scrollLeft, p = l.scrollTop, a = n), d({ scrollable: c, method: a, startTime: h, startX: f, startY: p, x: e, y: r }) } } "object" == typeof exports && "undefined" != typeof module ? module.exports = { polyfill: o } : o() }();

    /*Anchor In-Page Links*/

    window.addEventListener('DOMContentLoaded', () => {
        const anchorLinks = document.querySelectorAll('.js-smooth-scroll');
        const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

        anchorLinksArr.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                const targetId = link.hash;
                const targetElement = document.querySelector(targetId);
                const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            });
        });
    });

    // /*Pagetop*/
    // var ptt = document.getElementById("is-pagetop");
    // ptt.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     window.scroll({
    //         top: 0,
    //         behavior: 'smooth'
    //     })
    // });

    var _application = {
        bp: {
            md: 768
        }
    };
    var mql = window.matchMedia("(min-width:".concat(_application.bp.md / 16, "rem)"));
    var module = {
        cardListCarousel: function cardListCarousel($elms) {
            Array.prototype.forEach.call($elms, function ($elm) {
                var carousel;
                var $swiperContainer = $elm.querySelector('.swiper-container');
                var paginationConfig = {
                    el: $elm.querySelector('.swiper-pagination'),
                    type: 'bullets'
                };
                var settings = {
                    bpLess: {
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        pagination: paginationConfig,
                        spaceBetween: 32
                    }
                };

                var initializeSwiper = function initializeSwiper(mql) {
                    if (carousel) {
                        carousel.destroy(carousel);
                        carousel = null;
                    }

                    if (!mql.matches) {
                        carousel = new Swiper($swiperContainer, settings.bpLess);
                    } else {
                        if (carousel) {
                            carousel.destroy(carousel);
                        }
                    }
                };

                initializeSwiper(mql);
                mql.addListener(initializeSwiper);
            });
        },

        fadeUpShowHandle: function fadeUpShowHandle($elms) {
            Array.prototype.forEach.call($elms, function ($elm) {
                var options = {
                    rootMargin: '0px 0px -150px'
                };

                var addShowClass = function addShowClass(entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            $elm.classList.add('is-show');
                        }
                    });
                }; // const verticalPosition = $elm.scrollTop;
                // const windowScrollY = window.scrollY;
                // console.log(verticalPosition, windowScrollY);


                var observer = new IntersectionObserver(addShowClass, options);
                observer.observe($elm);
            });
        },
    };

    var eventCardTarget = '.js-eventCardList';
    var $eventCardCarousel = document.querySelectorAll(eventCardTarget);

    if ($eventCardCarousel.length !== 0) {
        module.cardListCarousel($eventCardCarousel);
    }

    // var modalTarget = '.js-modal-component';
    // var $modalTarget = document.querySelectorAll(modalTarget);

    // if ($modalTarget.length !== 0) {
    //     module.createModal($modalTarget);
    // }

    var fadeTarget = '.js-fadeUp-target';
    var $fadeTarget = document.querySelectorAll(fadeTarget);

    if ($fadeTarget.length !== 0) {
        module.fadeUpShowHandle($fadeTarget);
    }



    //header開閉
    $("#header-btn").on('click touchend', function (event) {
        event.preventDefault();
        $(".p-header").toggleClass("is-active");
    });

    //SmoothScroll
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,//スクロールする速さ
        header: '#header'//固定ヘッダーがある場合
    });

    // モーダルを取得
    const modal = document.getElementById("modal");
    // モーダルを表示するボタンを全て取得
    const openModalBtns = document.querySelectorAll(".js-open-modal");
    // モーダルを閉じるボタンを全て取得
    const closeModalBtns = document.querySelectorAll(".js-close-modal");

    // // Swiperの設定
    // const swiper = new Swiper(".swiper", {
    //     loop: true,
    //     navigation: {
    //         nextEl: ".school-modal__next",
    //         prevEl: ".school-modal__prev",
    //     },
    //     spaceBetween: 30,
    // });
    let swiperGroup = null;
    let modalIndex = null;
    let swiper = null;
    const modalInitSwiper = (swiperGroup, modalIndex) => {
        if ($(swiperGroup + " .swiper-slide").length == 1) {
            // スライドが1枚の時のオプションを追加
            swiper = new Swiper(swiperGroup, {
                initialSlide: modalIndex - 1,
                loop: false,
                on: {
                    init: function () {
                    },
                },
            });
        } else {
            // console.log("fixsss");
            swiper = new Swiper(swiperGroup, {
               initialSlide: modalIndex - 1 ,
                loop: true,
                navigation: {
                    nextEl: ".modal__next",
                    prevEl: ".modal__prev",
                },
                spaceBetween: 60,
                on: {
                    init: function () {
                    },
                    
                },
                onSlideChangeEnd: (s) => {
                    // console.log("fix");
                    
                    s.fixLoop();
                },
               
            });
        }
    };

    // モーダルを表示するボタンをクリックしたとき
    openModalBtns.forEach((openModalBtn) => {
        openModalBtn.addEventListener("click", () => {
            
            // data-slide-indexに設定したスライド番号を取得
            const modalIndex: number = openModalBtn.dataset.slideIndex;
            // data-modal-groupを取得
            const modalGroup = openModalBtn.dataset.modalGroup;
            const swiperGroup = '.' + modalGroup;
            modalInitSwiper(swiperGroup, modalIndex); 
            swiper.on('slideChange', () => {
                //loopで追加したスライドのイベントが発生しない問題のためもう一度関数実行
                // console.log('slide changed');
                $(".js-close-modal").on("click", () => {
                    $('.modal').removeClass('is-active');
                    $("body").removeClass("is-modal_active");
                    swiper.destroy(false, true);
                });
            });
            // swiper.slideTo(modalIndex);
            document.getElementById(modalGroup).classList.add("is-active");
            $("body").addClass("is-modal_active");
        });
        
    });

    // モーダルを閉じるボタンをクリックしたとき
    closeModalBtns.forEach((closeModalBtn) => {
        closeModalBtn.addEventListener("click", () => {
            console.log("click");
            // document.querySelectorAll(".modal").classList.remove("is-active");
            $('.modal').removeClass('is-active');
            $("body").removeClass("is-modal_active");
            swiper.destroy(false, true);
        });
    });


    // ///sp時にswiper起動
    // //Swiper
    // let secCaseSwiper_1 = null;
    // let secCaseSwiper_2 = null;
    // let secCaseSwiper_3 = null;
    // let secCaseSwiper_4 = null;
    // let secCaseSwiper_5 = null;
    // let secCaseSwiper_6 = null;
    // const mediaQuery = window.matchMedia('(max-width: 768px)');
    // const checkBreakpoint = (e) => {
    //     if (e.matches) {
    //         initSwiper_1();
    //         initSwiper_2();
    //         initSwiper_3();
    //         initSwiper_4();
    //         initSwiper_5();
    //         initSwiper_6();
    //     } else if (secCaseSwiper_1) {
    //         secCaseSwiper_1.destroy(false, true);
    //     } else if (secCaseSwiper_2) {
    //         secCaseSwiper_2.destroy(false, true);
    //     } else if (secCaseSwiper_3) {
    //         secCaseSwiper_3.destroy(false, true);
    //     } else if (secCaseSwiper_4) {
    //         secCaseSwiper_4.destroy(false, true);
    //     } else if (secCaseSwiper_5) {
    //         secCaseSwiper_5.destroy(false, true);
    //     } else if (secCaseSwiper_6) {
    //         secCaseSwiper_6.destroy(false, true);
    //     }
    // }

    // const initSwiper_1 = () => {
    //     secCaseSwiper_1 = new Swiper('.js-slider-sp-1', {
    //         slidesPerView: 'auto',
    //         centeredSlides: true,
    //         spaceBetween: 14,
    //         grabCursor: true,
    //         pagination: {
    //             el: '.p-slide__pagenation',
    //             clickable: true,
    //         },
    //     });
    // };
    // const initSwiper_2 = () => {
    //     secCaseSwiper_2 = new Swiper('.js-slider-sp-2', {
    //         slidesPerView: 'auto',
    //         centeredSlides: true,
    //         spaceBetween: 14,
    //         grabCursor: true,
    //         pagination: {
    //             el: '.p-slide__pagenation',
    //             clickable: true,
    //         },
    //     });
    // };
    // const initSwiper_3 = () => {
    //     secCaseSwiper_3 = new Swiper('.js-slider-sp-3', {
    //         slidesPerView: 'auto',
    //         centeredSlides: true,
    //         spaceBetween: 14,
    //         grabCursor: true,
    //         pagination: {
    //             el: '.p-slide__pagenation',
    //             clickable: true,
    //         },
    //     });
    // };
    // const initSwiper_4 = () => {
    //     secCaseSwiper_4 = new Swiper('.js-slider-sp-4', {
    //         slidesPerView: 'auto',
    //         centeredSlides: true,
    //         spaceBetween: 14,
    //         grabCursor: true,
    //         pagination: {
    //             el: '.p-slide__pagenation',
    //             clickable: true,
    //         },
    //     });
    // };
    // const initSwiper_5 = () => {
    //     secCaseSwiper_5 = new Swiper('.js-slider-sp-5', {
    //         slidesPerView: 'auto',
    //         centeredSlides: true,
    //         spaceBetween: 14,
    //         grabCursor: true,
    //         pagination: {
    //             el: '.p-slide__pagenation',
    //             clickable: true,
    //         },
    //     });
    // };
    // const initSwiper_6 = () => {
    //     secCaseSwiper_6 = new Swiper('.js-slider-sp-6', {
    //         slidesPerView: 'auto',
    //         centeredSlides: true,
    //         spaceBetween: 14,
    //         grabCursor: true,
    //         pagination: {
    //             el: '.p-slide__pagenation',
    //             clickable: true,
    //         },
    //     });
    // };
    // mediaQuery.addEventListener('change', checkBreakpoint);
    // checkBreakpoint(mediaQuery);
    $(function () {
        drawer();
        // homeHeroImageCarousel();
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        const scroll = new SmoothScroll('[data-scroll]', {
            speed: 1000,
            speedAsDuration: true,
            offset(anchor, toggle) {
                const globalHeader = document.getElementById('masthead');

                if (globalHeader) {
                    return globalHeader.clientHeight;
                }

                return 0;
            },
        });
    });
})
(window, document, jQuery);